export const dataGroupMapRef = 'data-group-map';
